import { PropsWithChildren, ReactNode } from 'react';
import { Label } from './ui/label';
import { cx } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

export interface LabeledInputProps {
  label: ReactNode;
  labelFor?: string;
  helpText?: ReactNode;
  className?: string;
  containerClassName?: string;
  error?: ReactNode;
}

export function LabeledInput({
  children,
  label,
  labelFor,
  helpText,
  className,
  containerClassName,
  error,
}: PropsWithChildren<LabeledInputProps>) {
  return (
    <div className={containerClassName}>
      <Label htmlFor={labelFor}>{label}</Label>
      {helpText && <p className="text-sm text-muted-foreground">{helpText}</p>}
      <div className={twMerge(cx('w-full mt-2 space-y-2', className))}>
        {children}
      </div>
      {error && <div className="text-red-500 mt-2">{error}</div>}
    </div>
  );
}
